// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const rattata: PokeData = {
  "id": 19,
  "name": "rattata",
  "height": 3,
  "weight": 35,
  "base_experience": 51,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "double-edge",
    "tail-whip",
    "bite",
    "quick-attack",
    "focus-energy",
    "hyper-fang",
    "super-fang",
    "pursuit",
    "crunch",
    "endeavor",
    "assurance",
    "sucker-punch",
    "laser-focus"
  ],
  "moves": [
    "tackle",
    "bite",
    "quick-attack",
    "pursuit",
    "crunch",
    "refresh",
    "headbutt",
    "supersonic",
    "body-slam",
    "tri-attack",
    "splash",
    "leer",
    "growl"
  ],
  "evolution_chain": {
    "id": 7,
    "item": null,
    "species": [
      {
        "name": "rattata",
        "order": 19,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "raticate",
        "order": 20,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 19,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 32.5,
    "speed": 72,
    "ability_power": 56
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
